import React from 'react';
import { TruckIcon } from '@heroicons/react/24/outline';
import ModuleAccessManagement from '../../components/ModuleAccessManagement';
import { vehicleMaintenanceApi } from '../../api/vehicleMaintenanceApi';

const VehicleMaintenanceAccessPage = () => (
  <ModuleAccessManagement
    title="Araç Bakım Erişimi"
    description="Araç takip modülünü görebilecek kullanıcıları seçin. Mail kutusu işaretli olanlara araç hatırlatma mailleri gider."
    api={vehicleMaintenanceApi}
    accent="rose"
    icon={TruckIcon}
    emailToggle
  />
);

export default VehicleMaintenanceAccessPage;
